export default __webpack_public_path__ + "static/media/tibs.9f56c3ac.jpg";